import { Injectable } from '@angular/core';

@Injectable()
export class SortingService {

	constructor() {
	}

	orderBy(data, property, type) {
		const dataCopy = [...data];

		if (dataCopy && dataCopy.length > 0) {
			const desc = property.substr(0, 1) === '-';
			const prop: string = property.substr(0, 1) === '+' || property.substr(0, 1) === '-'
					? property.substr(1)
					: property;

			dataCopy.sort((a, b) => {
				let aValue = a[prop];
				let bValue = b[prop];

				const propSplit = prop.split('.');
				if (typeof aValue === 'undefined' && typeof bValue === 'undefined' && propSplit.length > 1) {
					aValue = a;
					bValue = b;
					if (aValue[propSplit[0]]) {
						for (let i = 0; i < propSplit.length; i++) {
							aValue = aValue[propSplit[i]];
						}
					} else {
						aValue = null;
					}
					if (bValue[propSplit[0]]) {
						for (let i = 0; i < propSplit.length; i++) {
							bValue = bValue[propSplit[i]];
						}
					} else {
						bValue = null;
					}
				}

				if (aValue === null || typeof aValue === 'undefined' || aValue === '') { aValue = null; }
				if (bValue === null || typeof bValue === 'undefined' || bValue === '') { bValue = null; }

				if (type === 'string') {
					if (aValue) {
						aValue = aValue.toLowerCase();
					}
					if (bValue) {
						bValue = bValue.toLowerCase();
					}
				}

				let val;
				if (aValue === null) {
					val = -1;
				} else if (bValue === null) {
					val = 1;
				} else if (aValue === bValue) {
					val = 0;
				} else if (aValue > bValue) {
					val = 1;
				} else {
					val = -1;
				}

				if (!desc) {
					return val;
				} else {
					return -val;
				}
			});
			return dataCopy;
		} else {
			return;
		}
	}
}
